( function( $, document, window ) {
	'use strict';

	$( function() {
        const $item         = $( '.js-nav-menu-item' );
        const $link         = $( '.js-nav-menu-link' );
        const $dropdown     = $( '.js-nav-menu-dropdown' );
        const activeClass   = 'is-active';

        $link.on( 'click', function( e ) {
            e.stopPropagation();

            if ( $( this ).attr( 'href' ) === '#' ) {
                e.preventDefault();
            }

            const isActive = $( this ).closest( $item ).hasClass( activeClass );

            // remove active class from all other items
            $item.each( function() {
                if ( $( this ).hasClass( activeClass ) ) {
                    $( this ).removeClass( activeClass );
                }
            } );

            // if the current item is not active, make it active
            if ( ! isActive ) {
                $( this ).closest( $item ).addClass( activeClass );
                $('body').addClass('u-overflow-hidden');
            } else {
                $('body').removeClass('u-overflow-hidden');
            }
        } );

        // close the dropdown menu if clicked outside
        $( document ).on( 'click', function( e ) {
            if ( ! $( e.target ).closest( $dropdown ).length ) {
                $item.removeClass( activeClass );
                $('body').removeClass('u-overflow-hidden');
            }
        } );
	} );

} )( jQuery, document, window );
